import { useContext } from "react"
import { IndexGauge as SharedUiIndexGauge } from "shared-ui"
import ViewPortContext from "../../context/ViewPort"

export default function IndexGauge({ indexData, size = 80, showName, ...props }) {
    const { showCompactUI } = useContext(ViewPortContext)

    return <SharedUiIndexGauge
        indexData={indexData}
        size={size || (showCompactUI ? 50 : 70)}
        showName={showName}
        {...props}
    />
}
